import React, { useMemo } from 'react'
import { useTable } from 'react-table/dist/react-table.development'

const IngredientTable = ({ data }) => {
    const columnsWithout = React.useMemo(
        () => [
            {
                Header: 'Ingredient',
                accessor: 'IngredientName', // accessor is the "key" in the data
            },
            {
                Header: 'CAS Number',
                accessor: 'CASNumber',
            },
            {
                Header: '% HF Fluid',
                accessor: 'roundedPercentHFJobString',
            },
        ],
        []
    )

    const columnsComment = React.useMemo(
        () => [
            {
                Header: 'Ingredient',
                accessor: 'IngredientName', // accessor is the "key" in the data
            },
            {
                Header: 'CAS Number',
                accessor: 'CASNumber',
            },
            {
                Header: '% HF Fluid',
                accessor: 'roundedPercentHFJobString',
            },
            {
                Header: 'Ingredient Comment',
                accessor: 'IngredientComment',
            },
        ],
        []
    )

    const columns = useMemo(() => {
        let ingredientArray = []
        ingredientArray = data.Ingredients
        ingredientArray.forEach((element) => {
            // if (element.IngredientComment === "None" | "" | " " | null | isEmptyorSPace(element.IngredientComment)){
            //     setTableData(columnsWithout);
            // }
            // explicit !-- operators were not getting the null/blank checks done, unknown why, reverting to a length arguement
            if (element.IngredientComment.length > 4) {
                console.log(element.IngredientComment.length, '&&length')
                return columnsComment
            }
        })
        return columnsWithout
    }, [data, columnsComment, columnsWithout])

    const tableData = React.useMemo(() => {
        if (data) {
            return data.Ingredients
        } else {
            return []
        }
    }, [data])

    const tableInstance = useTable({ columns, data: tableData })

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        tableInstance

    return (
        <table id="ingredienttable" className="ingredient" {...getTableProps()}>
            <thead className="left">
                {headerGroups.map((headerGroup) => {
                    const { key, ...headerGroupProps } =
                        headerGroup.getHeaderGroupProps()
                    return (
                        <tr key={key} {...headerGroupProps}>
                            {headerGroup.headers.map((column) => {
                                const { key, ...props } =
                                    column.getHeaderProps()
                                return (
                                    <th key={key} {...props}>
                                        {column.render('Header')}
                                    </th>
                                )
                            })}
                        </tr>
                    )
                })}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row) => {
                    prepareRow(row)
                    const { key, ...rowProps } = row.getRowProps()
                    return (
                        <tr key={key} {...rowProps}>
                            {row.cells.map((cell) => {
                                const { key, ...cellProps } =
                                    cell.getCellProps()
                                return (
                                    <td key={key} {...cellProps}>
                                        {cell.render('Cell')}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default IngredientTable
